<template>
  <MainLayout>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="text-uppercase">
          <span>{{ isEditPage ? $t('edit') : $t('create') }} {{ $t('campaign_group') }}</span>
        </h1>
      </div>
      <div class="d-flex">
        <Button
          class="btn btn-color10"
          v-b-modal.cancel-campaign-upsert-modal
        >
          {{ $t('cancel') }}
        </Button>
        <CancelCampaignUpsertModal
          :campaign="campaign"
          :segmentation="segmentation"
          :step="isEditPage ? 'package' : 'campaign'"
        />
      </div>
    </div>
    <!-- CAMPAIGN LOADER -->
    <div v-if="campaignLoader" class="text-center">
      <Loader
        :size="'big'"
      />
    </div><!-- END CAMPAIGN LOADER -->
    <template v-else>
      <!-- PACKAGE FORM -->
      <div class="mt-3" v-if="!isEditPage || (isEditPage && segmentation)">
        <!-- HEADING -->
        <section class="my-4">
          <div class="col-lg-8 mx-auto text-center">
            <p>{{ $t('configure_campaign_groups_for_segmentation') }}</p>
          </div>
        </section> <!-- END HEADING -->
        <section class="">
          <div class="col-lg-10 mx-auto mb-5 position-relative">
            <div class="card">
              <div class="card-body">
                <CampaignPackageForm
                  v-if="campaign"
                  :base-campaign="campaign"
                  :currency="campaign.advertiser.currency"
                />
              </div>
            </div>
          </div>
        </section>
      </div><!-- END PACKAGE FORM -->
    </template>
  </MainLayout>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import variables from '@/mixins/variables'

import Button from '@/components/common/Button/Button'
import CampaignPackageForm from '@/components/campaigns/Programmatic/CampaignPackageForm'
import CancelCampaignUpsertModal from '@/components/campaigns/Modals/CancelCampaignUpsertModal'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'

import { mapActions, mapState } from 'vuex'

export default {
  mixins: [variables],
  components: {
    Button,
    CampaignPackageForm,
    CancelCampaignUpsertModal,
    Loader,
    MainLayout
  },
  data () {
    return {
      campaign: '',
      campaignLoader: false,
      loader: false,
      segmentation: ''
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  created () {
    this.getCampaign()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Check if is edit page
     */
    isEditPage () {
      return this.$route.name === 'packages.edit'
    },
    /**
     * Get page title
     */
    pageTitle () {
      return this.$route.name === 'packages.create' ? this.$t('create_group') : this.$t('edit_group')
    }
  },
  methods: {
    ...mapActions('campaigns', [
      'setCurrentCampaign'
    ]),
    /**
     * Get campaign
     */
    async getCampaign () {
      this.campaignLoader = true
      try {
        const campaign = await CampaignsService.getCampaign(this.$route.params.cId)
        if (campaign.status === 'FINISHED') return this.$router.push({ name: 'campaigns.show', params: { id: campaign.id } })
        this.campaign = campaign
        this.segmentation = this.campaign.packages.find(item => {
          return item.id === this.$route.params.id
        })
        this.campaignLoader = false
        if (!this.segmentation) return
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.$router.push('/')
      }
      this.campaignLoader = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
